import {
  GET_DETAIL_ATTENDANCE_IDP_STRUCTURED_LEARNING,
  GET_DETAIL_EVENT_ATTENDANCE_IDP_STRUCTURED_LEARNING,
  GET_LIST_ATTENDANCE_IDP_STRUCTURED_LEARNING,
  SUBMIT_ATTENDANCE_IDP_STRUCTURED_LEARNING,
} from "@/api/idp/attendance";

const handleRequest = async (apiFunc, commit, mutation, args, emptyValue = []) => {
  try {
    const resp = await apiFunc(args);
    const { httpCode, data } = resp.data;

    if (httpCode === 200) {
      if (data?.data && data?.totalItems !== undefined) {
        commit(mutation, {
          data: data.data,
          totalItems: data.totalItems,
          page: data.page,
          limit: data.limit,
          totalPages: data.totalPages,
        });
      } else {
        commit(mutation, data);
      }
      return data;
    }

    commit(mutation, emptyValue);
    return emptyValue;
  } catch (err) {
    const resp = err?.response?.data;
    if (resp?.httpCode === 404) {
      commit(mutation, emptyValue);
    }
    throw err;
  }
};

const state = {
  attendances: {
    data: [],
    totalItems: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  detailEvent: null,
  detailAttendance: null,
};

const mutations = {
  setAttendances: (state, payload) => {
    state.attendances = {
      data: payload.data ?? [],
      totalItems: payload.totalItems ?? 0,
      page: payload.page ?? 1,
      limit: payload.limit ?? 10,
      totalPages: payload.totalPages ?? 1,
    };
  },

  setDetailEvent: (state, payload) => {
    state.detailEvent = payload;
  },

  setDetailAttendance: (state, payload) => {
    state.detailAttendance = payload;
  },

  resetAttendances: (state) => {
    state.attendances = {
      data: [],
      totalItems: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
    };
  },

  resetDetailEvent: (state) => {
    state.detailEvent = null;
  },

  resetDetailAttendance: (state) => {
    state.detailAttendance = null;
  },
};

const actions = {
  async getAttendances({ commit }, query) {
    return handleRequest(GET_LIST_ATTENDANCE_IDP_STRUCTURED_LEARNING, commit, "setAttendances", query, []);
  },

  async submitAttendance(_, { id }) {
    return SUBMIT_ATTENDANCE_IDP_STRUCTURED_LEARNING(id);
  },

  async getDetailEvent({ commit }, query) {
    const resp = await handleRequest(
      GET_DETAIL_EVENT_ATTENDANCE_IDP_STRUCTURED_LEARNING,
      commit,
      "setDetailEvent",
      query,
      null
    );
    return resp;
  },

  async getDetailAttendance({ commit }, query) {
    const resp = await handleRequest(
      GET_DETAIL_ATTENDANCE_IDP_STRUCTURED_LEARNING,
      commit,
      "setDetailAttendance",
      query,
      null
    );
    return resp;
  },

  resetDataAttendance({ commit }) {
    commit("resetAttendances");
    commit("resetDetailEvent");
    commit("resetDetailAttendance");
  },
};

const getters = {
  attendances: (state) => state.attendances,
  detailEvent: (state) => state.detailEvent,
  detailAttendance: (state) => state.detailAttendance,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
